module.exports = __webpack_public_path__ + "front/img/p4.6abbaa87.png";